export function OutlinePlayIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 19.026V4.96926C7 3.21746 9.1144 2.34156 10.3529 3.58007L17.3836 10.6108C18.1512 11.3784 18.1512 12.6216 17.3836 13.3892L10.3529 20.4199C9.1144 21.6584 7 20.7825 7 19.0307V19.026Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
